module.exports = __webpack_public_path__ + "static/media/check.1f4f135b.svg";